<template>
  <div class="static-value-row">
    <div class="static-value-row__col static-value-row__col--code">
      <TextInput
        :id="`sv-code-${index}`"
        :modelValue="value.supplierCode"
        @update:modelValue="$emit('update', { supplierCode: $event })"
        placeholder="P08"
        size="sm"
        label="Code"
      />
    </div>
    <div class="static-value-row__col static-value-row__col--value">
      <TextInput
        :id="`sv-val-${index}`"
        :modelValue="value.value"
        @update:modelValue="$emit('update', { value: $event })"
        placeholder="08.21"
        size="sm"
        label="Waarde"
      />
    </div>
    <div class="static-value-row__col static-value-row__col--label">
      <TextInput
        :id="`sv-label-${index}`"
        :modelValue="value.label"
        @update:modelValue="$emit('update', { label: $event })"
        placeholder="omschrijving (optioneel)"
        size="sm"
        label="Label"
      />
    </div>
    <div class="static-value-row__col static-value-row__col--actions">
      <Btn variant="plain" size="xs" icon="trash" @click="$emit('remove')" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import TextInput from '@/components/inputs/TextInput.vue';
import Btn from '@/components/partials/Btn.vue';

export default defineComponent({
  name: 'StaticValueRow',
  components: { TextInput, Btn },

  props: {
    value: { type: Object, required: true },
    catalogFields: { type: Array, default: () => [] },
  },

  emits: ['update', 'remove'],

  setup() {
    return {};
  },
});
</script>

<style scoped lang="scss">
.static-value-row {
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  padding: 0.375rem 0;
  border-bottom: 1px solid var(--border-color-light);

  &:last-child {
    border-bottom: none;
  }

  &__col {
    &--code { flex: 1; max-width: 120px; }
    &--value { flex: 1; max-width: 120px; }
    &--label { flex: 2; }
    &--actions {
      flex: 0 0 40px;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 0.25rem;
    }
  }
}
</style>
